import React from 'react';
import { motion } from 'framer-motion';
import { Footer } from '../components/Footer';
export function MetodoBatchPage() {
  const fadeIn = {
    initial: {
      opacity: 0,
      y: 20
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true
    },
    transition: {
      duration: 0.6
    }
  };
  return <div className="min-h-screen bg-[#FFF8F0] font-sans selection:bg-[#FFCC80] selection:text-gray-900 pt-10 md:pt-16 flex flex-col" data-id="element-1132">
      <main className="max-w-3xl mx-auto px-4 pb-20 flex-grow w-full" data-id="element-1133">
        <motion.section {...fadeIn} className="text-center py-16 md:py-24" data-id="element-1134">
          <h1 className="text-4xl md:text-5xl font-black text-gray-900 leading-tight mb-6" data-id="element-1135">
            Método Batchcooking
          </h1>
          <p className="text-xl text-gray-600" data-id="element-1136">Contenido próximamente.</p>
        </motion.section>
      </main>
      <Footer data-id="element-1137" />
    </div>;
}